import {BaseApi} from '@/api/base.api.js'
import {replaceUnicode} from '@/helpers/string.js'

/**
 * Image API service
 */
export class ImageApi extends BaseApi {

  //Props
  basePath = '/'

  /**
   * Generate signed URL for existing image key
   */
  async generateSignedUrl(imageKey) {

    //Get data
    const data = await this.post('/generate_presigned_url_for_vue_image_url', {
      image_key: imageKey,
    })

    //Return URL (the JSON parse converts unicode characters)
    return replaceUnicode(data.presigned_url)
  }
}

//Export singleton instance
export const imageApi = new ImageApi()
